import {inject} from '@angular/core';
import {DienststellenService} from '../services/apiservices/dienststellen.service';
import {AnliegenService} from '../services/apiservices/anliegen.service';
import {DienststellenVorbelegung} from '../model/dienststellen-vorbelegung';
import {NachrichtenTypeEnum} from '../model/nachricht/nachrichten-type.enum';
import {AnliegenMap} from '../model/anliegen-map';
import {forkJoin, map, Observable, of, switchMap} from 'rxjs';
import {DienststellenMap} from '../model/dienststellen-map';
import {rechteResolver} from "./rechte.resolver";

export const dienststellenAnliegenMapResolver = (): Observable<{
    dienststellenMap: DienststellenMap;
    anliegenMap: AnliegenMap;
}> => {
    const dienststellenService = inject(DienststellenService);
    const anliegenService = inject(AnliegenService);

    return rechteResolver().pipe(
        switchMap(() => dienststellenService.getDienststellenVorbelegung()),
        map(convertToDienststellenMap),
        switchMap((dienststellenMap) => {
            const anliegenCalls: Partial<Record<NachrichtenTypeEnum, Observable<any>>> = {};

            if (dienststellenMap[NachrichtenTypeEnum.AA]?.teilnehmend) {
                anliegenCalls[NachrichtenTypeEnum.AA] = anliegenService.getAnliegen(
                    NachrichtenTypeEnum.AA,
                    dienststellenMap[NachrichtenTypeEnum.AA].dienststellenNummer
                );
            }

            if (dienststellenMap[NachrichtenTypeEnum.JC]?.teilnehmend) {
                anliegenCalls[NachrichtenTypeEnum.JC] = anliegenService.getAnliegen(
                    NachrichtenTypeEnum.JC,
                    dienststellenMap[NachrichtenTypeEnum.JC].dienststellenNummer
                );
            }

            if (dienststellenMap[NachrichtenTypeEnum.FAMKA]?.teilnehmend) {
                anliegenCalls[NachrichtenTypeEnum.FAMKA] = anliegenService.getAnliegen(
                    NachrichtenTypeEnum.FAMKA,
                    dienststellenMap[NachrichtenTypeEnum.FAMKA].dienststellenNummer
                );
            }

            if (dienststellenMap[NachrichtenTypeEnum.ZAV]?.teilnehmend) {
                anliegenCalls[NachrichtenTypeEnum.ZAV] = anliegenService.getAnliegen(
                    NachrichtenTypeEnum.ZAV,
                    dienststellenMap[NachrichtenTypeEnum.ZAV].dienststellenNummer
                );
            }

            if (Object.keys(anliegenCalls).length === 0) {
                return of({dienststellenMap, anliegenMap: {} as AnliegenMap});
            }

            return forkJoin(anliegenCalls).pipe(
                map((anliegenMap) => ({
                    dienststellenMap,
                    anliegenMap: anliegenMap as AnliegenMap
                }))
            );
        })
    );
};

function convertToDienststellenMap(v: DienststellenVorbelegung): DienststellenMap {
    return {
        [NachrichtenTypeEnum.AA]: v.dstVorbelegungSGB3,
        [NachrichtenTypeEnum.JC]: v.dstVorbelegungSGB2,
        [NachrichtenTypeEnum.FAMKA]: v.dstVorbelegungFamka,
        [NachrichtenTypeEnum.ZAV]: v.dstVorbelegungZav
    };
}